module.exports = __webpack_public_path__ + "images/icons/logos/partner-white-9c246a09.svg";